import { f7ready } from 'framework7-react';

import dayjs from 'dayjs';

export const useTimePickerModal = () => {
  const openTimePickerModal = ({
    startDate,
    startTime,
    toolbarCloseText = 'Continue',
    onClose,
  }: {
    startDate: string;
    startTime?: string;
    toolbarCloseText?: string;
    onClose: (date: Date) => void;
  }) => {
    f7ready((f7) => {
      const calendarModal = f7.calendar.create({
        openIn: 'customModal',
        minDate: dayjs(startDate).startOf('day').toDate(),
        maxDate: dayjs(startDate).endOf('day').toDate(),
        value: [dayjs(`${startDate} ${startTime ?? '19:00'}`).toDate()],
        renderHeader: () =>
          `<div style="padding: 8px 16px; font-size: 18px; font-weight: 500;">${dayjs(startDate).format('ddd, D MMM')}</div>`,
        renderWeekHeader: () => '',
        cssClass: 'timepicker-calendar',
        renderMonths: () => '<div style="height: 0;"></div>',
        header: true,
        toolbar: false,
        footer: true,
        toolbarCloseText,
        timePicker: true,
        yearPicker: false,
        monthPicker: false,
        on: {
          close: (calendar) => {
            const [date] = calendar.getValue() ?? [];
            if (date) {
              onClose(date);
            }
            calendar.destroy();
          },
        },
      });

      calendarModal.open();
    });
  };

  return { openTimePickerModal };
};
